import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Input } from 'reactstrap'
import SearchIcon from "../../static/images/search_icon.svg"
import { FONTS, COLORS } from '../../constants'

export default class SearchBar extends React.Component {
  state={ tempState: '' }

  render() {
    return (
      <Wrapper>
        <WrapperButton>
          <SearchField
            placeholder={ 'Search By Name, ID' }
            value={ this.state.tempState }
            onChange={ (e) => {
              if (e.target.value === '') this.props.handleSearch('')
              this.setState({ tempState: e.target.value })
            } }
            onKeyDown={ (e) => {
              if (e.keyCode === 13) this.props.handleSearch(this.state.tempState)
            } }
          />
          <CustomButton
            onClick={ () => this.props.handleSearch(this.state.tempState) }
          >Search</CustomButton>
        </WrapperButton>
        <CustomButton
          bg={ COLORS.SECONDARY_RED }
          border={ COLORS.PRIMARY_RED_BORDER }
          onClick={ () => this.props.toggleCreate() }
        >+ Create</CustomButton>
      </Wrapper>

    )
  }
}

SearchBar.propTypes = {
  handleSearch: PropTypes.func,
  toggleCreate: PropTypes.func,
}
SearchBar.defaultProps = {
  handleSearch: () => {},
  toggleCreate: () => {},
}

const WrapperButton = styled.div`
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 40px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`




// WEBPACK FOOTER //
// ./src/components/client/search-bar.js